module.exports = __webpack_public_path__ + "img/RegFees-4-exhibition.ab23d677.svg";